import colors from 'components/utils/colors'

// 30 minutes. Should be in sync with the same backend timeout
export const SESSION_TIMEOUT_SEC = 30 * 60

export const DASHBOARD_TIME_INTERVAL_SUMMARY = 'summary'
export const DASHBOARD_TIME_INTERVAL_1D = '1'
export const DASHBOARD_TIME_INTERVAL_2D = '2'
export const DASHBOARD_TIME_INTERVAL_7D = '7'
export const DASHBOARD_TIME_INTERVAL_30D = '30'

export const requestsFilterValuesCodes = [
  { id: 'all', name: 'All' },
  { id: '2XX', name: '2XX' },
  { id: '4XX', name: '4XX' },
  { id: '5XX', name: '5XX' },
]

export const requestsFilterValuesEntities = [
  { id: 'all', name: 'All' },
  { id: 'attachments', name: 'attachments' },
  { id: 'comments', name: 'comments' },
  { id: 'statuses', name: 'statuses' },
]

export const subscriptionFilterValues = [
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
]

export const newSubscriptionFilterValues = [
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
]

export const lastLoginFilterValue = [
  { value: 'LAST_HOUR', label: 'Last hour' },
  { value: 'TODAY', label: 'Today' },
  { value: 'YESTERDAY', label: 'Yesterday' },
  { value: 'LAST_7_DAYS', label: 'Last 7 days' },
  { value: 'LAST_14_DAYS', label: 'Last 14 days' },
  { value: 'LAST_30_DAYS', label: 'Last 30 days' },
]

export const typeFiltersValues = [
  { value: 'GLOBAL', label: 'Global' },
  { value: 'PRIVATE', label: 'Private' },
]

export const AVAILABLE_LOCALES = [
  { value: 'en', label: 'English (US)' },
  { value: 'eu_sky', label: 'English (UK)' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' },
]

export const acceptedLogosTypes = '.jpeg,.jpg,.png,.bmp,.gif,.svg,.raw,.tiff'

export const NAV_BAR_HEIGHT = 48
export const MEGA_MENU_LINE_LENGTH = 28
export const FOOTER_HEIGHT = 32

export const TICKET_FILTER_OPERATOR_COLORS = {
  'not equal': colors.bgStatus1,
  'not like': colors.bgStatus2,
  'not empty': colors.bgStatus3,
  'not in': colors.bgStatus4,
  'in': colors.bgStatus5,
  '>': colors.bgStatus6,
  'like': colors.bgStatus7,
  '>=': colors.bgStatus8,
  '<': colors.bgStatus9,
  '<=': colors.bgStatus10,
  'empty': colors.bgStatus11,
  'equal': colors.bgStatus12,
  'is': colors.bgStatus14,
}

export const COMPARISON_OPERATORS = ['>', '>=', '<', '<=']

export const DATE_COMPARISON_ALLOWED_VALUES = [
  { value: 'START_OF_TODAY', name: 'Start of Today' },
  { value: 'START_OF_WEEK_MON', name: 'Start of Week (Mon-Sun)' },
  { value: 'START_OF_WEEK_SUN', name: 'Start of Week (Sun-Sat)' },
  { value: 'END_OF_TODAY', name: 'End of Today' },
  { value: 'END_OF_WEEK_MON', name: 'End of Week (Mon-Sun)' },
  { value: 'END_OF_WEEK_SUN', name: 'End of Week (Sun-Sat)' },
]
